(function () {
  var PACKETA_API_KEY = 'cad52c39b23e60eb';
  var isChoosingPickupPoint = false;
  var mobileQuery = window.matchMedia('(max-width: 749px), (pointer: coarse)');
  var checkoutSelectors = [
    'button[name="checkout"]',
    'input[name="checkout"]',
    'a[href="/checkout"]',
    'a[href^="/checkout?"]'
  ].join(',');

  function getPacketaConfig() {
    var country = (document.body.dataset.shopCountry || '').toUpperCase();
    var language = (document.body.dataset.shopLanguage || document.documentElement.lang || '').toLowerCase();

    if (country === 'CZ') {
      return {
        country: 'cz',
        language: 'cs',
        cartCountry: 'CZ',
        notice: 'P\u0159ed vypln\u011bn\u00edm \u00fadaj\u016f pros\u00edm vyberte svou Z\u00e1silkovnu.'
      };
    }

    if (country === 'SK') {
      return {
        country: 'sk',
        language: 'sk',
        cartCountry: 'SK',
        notice: 'Pred vyplnen\u00edm \u00fadajov pros\u00edm vyberte svoju Z\u00e1sielkov\u0148u.'
      };
    }

    if (!country && language.indexOf('cs') === 0) {
      return {
        country: 'cz',
        language: 'cs',
        cartCountry: 'CZ',
        notice: 'P\u0159ed vypln\u011bn\u00edm \u00fadaj\u016f pros\u00edm vyberte svou Z\u00e1silkovnu.'
      };
    }

    if (!country && language.indexOf('sk') === 0) {
      return {
        country: 'sk',
        language: 'sk',
        cartCountry: 'SK',
        notice: 'Pred vyplnen\u00edm \u00fadajov pros\u00edm vyberte svoju Z\u00e1sielkov\u0148u.'
      };
    }

    return null;
  }

  function buildAddress(point) {
    return [
      point.formatedAddress,
      point.formattedAddress,
      point.address,
      [point.street, point.city, point.zip || point.postcode].filter(Boolean).join(', ')
    ].find(Boolean) || '';
  }

  function savePickupPoint(point, config) {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        attributes: {
          'Packeta ID': point.id || '',
          'Packeta nazev': point.name || '',
          'Packeta adresa': buildAddress(point),
          'Packeta zeme': config.cartCountry,
          'Zasilkovna ID': point.id || '',
          'Zasilkovna nazev': point.name || '',
          'Zasilkovna adresa': buildAddress(point)
        }
      })
    });
  }

  function goToCheckout() {
    window.location.href = '/checkout';
  }

  function delay(milliseconds) {
    return new Promise(function (resolve) {
      window.setTimeout(resolve, milliseconds);
    });
  }

  function resetCheckoutButtons() {
    document.querySelectorAll(checkoutSelectors).forEach(function (button) {
      button.removeAttribute('aria-busy');
      button.removeAttribute('disabled');
      button.classList.remove('loading');
    });
  }

  function waitForPacketa() {
    var attempts = 0;

    return new Promise(function (resolve, reject) {
      function check() {
        if (window.Packeta && window.Packeta.Widget) {
          resolve();
          return;
        }

        attempts += 1;

        if (attempts > 40) {
          reject(new Error('Packeta widget did not load'));
          return;
        }

        window.setTimeout(check, 100);
      }

      check();
    });
  }

  function closeCartDrawer() {
    var drawer = document.querySelector('theme-drawer#cart-drawer');
    var dialog = drawer ? drawer.querySelector('dialog[open]') : null;
    var closeButton = drawer ? drawer.querySelector('.theme-drawer__close-button') : null;
    var drawerIsOpen = Boolean(drawer && (drawer.hasAttribute('open') || dialog));

    if (!drawerIsOpen) return Promise.resolve();

    if (closeButton) closeButton.click();

    if (drawer && typeof drawer.close === 'function') {
      Promise.resolve(drawer.close()).catch(function () {});
    }

    return delay(450).then(function () {
      var currentDialog = drawer ? drawer.querySelector('dialog[open]') : null;

      if (currentDialog && typeof currentDialog.close === 'function') {
        currentDialog.close();
      }

      if (drawer) drawer.removeAttribute('open');
      document.documentElement.classList.remove('theme-drawer-open');
      document.body.classList.remove('theme-drawer-open');
    });
  }

  function showPickupPointNotice(message) {
    var existingNotice = document.querySelector('[data-zasilkovna-checkout-notice]');
    if (existingNotice) existingNotice.remove();

    var notice = document.createElement('div');
    notice.setAttribute('data-zasilkovna-checkout-notice', '');
    notice.textContent = message;
    notice.style.cssText = [
      'position:fixed',
      'left:16px',
      'right:16px',
      'top:16px',
      'z-index:2147483647',
      'background:#111',
      'color:#fff',
      'padding:12px 14px',
      'border-radius:6px',
      'box-shadow:0 8px 24px rgba(0,0,0,.18)',
      'font:15px/1.35 system-ui,-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif',
      'text-align:center'
    ].join(';');

    document.body.appendChild(notice);
    window.setTimeout(function () {
      if (notice.parentNode) notice.remove();
    }, 4500);
  }

  function createInlineWidget(config) {
    var existingOverlay = document.querySelector('[data-zasilkovna-widget-overlay]');
    if (existingOverlay) existingOverlay.remove();

    var overlay = document.createElement('div');
    overlay.setAttribute('data-zasilkovna-widget-overlay', '');
    overlay.innerHTML = [
      '<div class="zasilkovna-widget-header">',
      '  <strong>' + config.notice + '</strong>',
      '  <button type="button" class="zasilkovna-widget-close" aria-label="Zavrit vyber Zasilkovny">Zavrit</button>',
      '</div>',
      '<div class="zasilkovna-widget-body" data-zasilkovna-widget-body></div>'
    ].join('');

    var style = document.createElement('style');
    style.setAttribute('data-zasilkovna-widget-style', '');
    style.textContent = [
      '[data-zasilkovna-widget-overlay]{position:fixed;inset:0;z-index:2147483647;background:#fff;display:flex;flex-direction:column;}',
      '.zasilkovna-widget-header{display:flex;align-items:center;justify-content:space-between;gap:12px;padding:12px 16px;border-bottom:1px solid rgba(0,0,0,.12);font:16px/1.3 system-ui,-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif;}',
      '.zasilkovna-widget-close{appearance:none;border:1px solid rgba(0,0,0,.25);background:#fff;border-radius:6px;padding:8px 12px;font:14px/1.2 system-ui,-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif;}',
      '.zasilkovna-widget-body{flex:1;min-height:0;}',
      '.zasilkovna-widget-body iframe{width:100%!important;height:100%!important;}'
    ].join('');

    document.head.appendChild(style);
    document.body.appendChild(overlay);
    document.body.style.overflow = 'hidden';

    overlay.querySelector('.zasilkovna-widget-close').addEventListener('click', function () {
      closeInlineWidget();
      isChoosingPickupPoint = false;
      if (window.Packeta && window.Packeta.Widget) window.Packeta.Widget.close();
    });

    return overlay.querySelector('[data-zasilkovna-widget-body]');
  }

  function closeInlineWidget() {
    var overlay = document.querySelector('[data-zasilkovna-widget-overlay]');
    var style = document.querySelector('[data-zasilkovna-widget-style]');
    if (overlay) overlay.remove();
    if (style) style.remove();
    document.body.style.overflow = '';
  }

  function choosePickupPoint() {
    if (isChoosingPickupPoint) return;

    var config = getPacketaConfig();
    if (!config) {
      goToCheckout();
      return;
    }

    if (!PACKETA_API_KEY || PACKETA_API_KEY.length !== 16) {
      alert('V kodu chybi API klic Zasilkovny.');
      return;
    }

    isChoosingPickupPoint = true;
    showPickupPointNotice(config.notice);
    resetCheckoutButtons();

    closeCartDrawer()
      .then(waitForPacketa)
      .then(function () {
        var inlineElement = mobileQuery.matches ? createInlineWidget(config) : null;

        window.Packeta.Widget.pick(PACKETA_API_KEY, function (point) {
          isChoosingPickupPoint = false;
          closeInlineWidget();
          resetCheckoutButtons();

          if (!point) return;

          savePickupPoint(point, config)
            .then(function (response) {
              if (!response.ok) throw new Error('Cart update failed');
              goToCheckout();
            })
            .catch(function () {
              alert('Vydejni misto se nepodarilo ulozit. Zkuste to prosim znovu.');
            });
        }, {
          country: config.country,
          language: config.language
        }, inlineElement);
      })
      .catch(function () {
        isChoosingPickupPoint = false;
        resetCheckoutButtons();
        alert('Vyber Zasilkovny se nepodarilo nacist. Zkuste to prosim znovu.');
      });
  }

  document.addEventListener('click', function (event) {
    var checkoutButton = event.target.closest(checkoutSelectors);

    if (!checkoutButton || checkoutButton.disabled || checkoutButton.getAttribute('aria-disabled') === 'true') return;
    if (!getPacketaConfig()) return;

    event.preventDefault();
    event.stopPropagation();
    choosePickupPoint();
  }, true);

  document.addEventListener('submit', function (event) {
    if (!event.target || event.target.id !== 'cart-form') return;

    var submitter = event.submitter;
    if (submitter && submitter.name !== 'checkout') return;
    if (!getPacketaConfig()) return;

    event.preventDefault();
    event.stopPropagation();
    choosePickupPoint();
  }, true);
})();
